<template>
  <login-layout title="인카 모기지 관리자화면 로그인">
    <input
        type="text"
        id="loginId"
        autocomplete="off"
        placeholder="ID(사번)"
        v-model="id"
        :disabled="isAuth"
        :class="{disabled: isAuth}"
    />
    <input
        type="text"
        id="loginPw"
        ref="loginPw"
        autocomplete="off"
        placeholder="비밀번호"
        @keypress.enter="login"
        :value="maskedPassword"
        @input="onPasswordInput($event)"
        :disabled="isAuth"
        :class="{disabled: isAuth}"
    />
    <input
        v-if="isAuth"
        type="text"
        id="authCode"
        ref="authCode"
        v-model="authCode"
        autocomplete="off"
        placeholder="인증번호"
        @keypress.enter="auth"
        maxlength="6"
    />
    <div v-if="isAuth" class="limit-timer">
      <span>{{ formattedTime }}</span>
    </div>
    <div class="login-button">
      <v-btn class="px-12" color="primary" @click="isAuth ? auth() : login()" :disabled="authCodeLength">
        {{ isAuth ? "인증" : "로그인" }}
      </v-btn>
    </div>
    <div class="buttons-layout text-no-wrap">
      <span class="button" @click="navigatePage('/findId')">아이디찾기</span>
      <div class="divider-layout">
        <span class="divider">|</span>
      </div>
      <span class="button" @click="navigatePage('/findPw')">비밀번호찾기</span>
    </div>
  </login-layout>
</template>

<script>
import {axiosInstance} from "@/util/AxiosModule";
import _ from "lodash";
import LoginLayout from "@/pages/Login/layout/LoginLayout.vue";

export default {
  name: "Login",
  components: {LoginLayout},
  data() {
    return {
      id: "",
      password: "",
      maskedPassword: "",
      authCode: "",
      startTime: null,
      endTime: null,
      limitTime: 5 * 60,
      remainingTime: 300,
      timerInterval: null,
      isAuth: false,
      regExp: /[^a-zA-Z0-9]/g,
      userContents: [
        { text: "회원가입", disable: false, href: "" },
        { text: "아이디찾기", disable: false, href: "findId" },
        { text: "비밀번호찾기", disable: false, href: "findPw" }
      ]
    }
  },
  computed: {
    formattedTime() {
      const absTime = Math.abs(this.remainingTime);
      const minutes = Math.floor(absTime / 60);
      const seconds = absTime % 60;
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },
    authCodeLength() {
      return this.isAuth && this.authCode.length !== 6;
    }
  },
  methods: {
    onPasswordInput(e) {
      const input = e.target;
      const newPass = input.value;
      const oldMasked = this.maskedPassword;
      const oldPass = this.password;

      const cursorPos = input.selectionStart;

      if (newPass.length < oldMasked.length) {
        const diff = oldMasked.length - newPass.length;
        this.password = oldPass.slice(0, cursorPos) + oldPass.slice(cursorPos + diff);
      } else {
        const added = newPass.length - oldMasked.length;
        const newChars = newPass.slice(cursorPos - added, cursorPos);
        this.password = oldPass.slice(0, cursorPos - added) + newChars + oldPass.slice(cursorPos - added);
      }

      this.maskedPassword = "•".repeat(this.password.length);
    },
    async login() {
      this.$refs.loginPw?.blur();

      const loginDto = {
        id: this.id,
        password: this.password
      };

      if (!loginDto["id"] || !loginDto["password"]) {
        await this.showAlert({message: "로그인 정보를 확인해주세요."});
        return false;
      }

      await axiosInstance.post("/public/login", loginDto)
          .then(() => {
            this.isAuth = true;
            this.startTimer();
          })
          .catch((error) => {
            this.showAlert({message: `${error.response.data.message}`});
          })
    },
    startTimer() {
      this.startTime = Date.now();
      this.endTime = this.startTime + this.limitTime * 1000;

      this.timerInterval = setInterval(() => {
        const now = Date.now();
        const diff = Math.ceil((this.endTime - now) / 1000);
        this.remainingTime = diff;

        if (diff < 0) {
          this.showAlert({message: "인증시간이 만료되었습니다"});
          this.resetTimer();
        }
      }, 1000);
    },
    async auth() {
      if (this.authCodeLength) return;
      const loginCompDto = {
        id: this.id,
        authCode: this.authCode
      };
      try {
        const { data } = await axiosInstance.post("/public/loginComp", loginCompDto);
        await this.$store.dispatch("login/login", data, {root: true});
        this.resetTimer();
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
        document.activeElement.blur();
      }
    },
    resetTimer() {
      clearInterval(this.timerInterval);
      this.startTime = null;
      this.endTime = null;
      this.limitTime =  5 * 60;
      this.remainingTime = 300;
      this.timerInterval = null;
      this.isAuth = false;
      this.authCode = "";
    },
    navigatePage(path) {
      if (_.isEmpty(path)) {
        return false;
      } else {
        const routePath = path;
        if (this.$route.path !== routePath) {
          this.$router.push(routePath);
        }
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
  }
}
</script>

<style lang="scss" scoped>
#loginId,
#loginPw,
#authCode {
  border: 1px solid #c0c0c0;
  border-radius: 5px;
  padding: 15px 10px;
  margin: 8px 0;
  font-size: 1.1rem;
}
.disabled {
  background-color: #e0e0e0;
  color: #c0c0c0;
}
#authCode {
  //margin-bottom: 20px;
}
.limit-timer {
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 0 5px;
  margin-bottom: 10px;
  span {
    color: red;
  }
}
.login-button {
  margin-top: 10px;
}
.buttons-layout {
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  .divider-layout {
    padding: 0 10px;
  }
  .button {
    cursor: pointer;
  }
  .button:hover {
    color: #1772C7;
  }
}
</style>